import type {
  ArchiveEvent,
  BookingAgency,
  FeaturedGuest,
  MoctEvent,
  Resident,
  TimelineEntry,
  Venue,
  VenueId,
} from '@/types';

export const VENUES: Record<VenueId, Venue> = {
  hayfilm: {
    id: 'hayfilm',
    name: 'HAYFILM CLUSTER',
    address: 'Ashtarak Highway 30',
    city: 'Yerevan',
    coords: '40.2098N / 44.4880E',
    stages: ['MAIN STAGE', 'BLUE STUDIO', 'BROWN STUDIO', 'PROJECTOR ROOM'],
  },
  ayrarat: {
    id: 'ayrarat',
    name: 'AYRARAT CINEMA',
    address: 'Sayat-Nova Ave 40',
    city: 'Yerevan',
    coords: '40.1810N / 44.5145E',
    stages: ['MAIN HALL'],
  },
};

export const UPCOMING: MoctEvent[] = [
  {
    id: 'juan-atkins',
    code: 'M-2026-001',
    title: 'JUAN ATKINS',
    subtitle: 'METROPLEX. DETROIT.',
    date: '2026-02-20',
    doors: '23:00',
    close: '06:00',
    venue: 'hayfilm',
    state: 'available',
    capacity: 1200,
    sold: 540,
    posterUrl: '/images/posters/juan-atkins.jpg',
    tiers: [
      { id: 'early', name: 'EARLY-BIRD', price: 5000, qty: 50, remaining: 0, note: 'SOLD OUT' },
      { id: 'wave1', name: 'WAVE 1', price: 8000, qty: 150, remaining: 32, note: 'LIMITED' },
      { id: 'wave2', name: 'WAVE 2', price: 10000, qty: 300, remaining: 188, note: 'OPEN' },
      { id: 'door', name: 'DOOR', price: 14000, qty: null, remaining: null, note: 'IF AVAILABLE' },
    ],
    lineup: {
      'MAIN STAGE': ['JUAN ATKINS', 'KARINA SAAKYAN', 'HOPDOP', 'IS (AM)'],
      'PROJECTOR ROOM': ['NEBELL', 'HESSILESS', 'MIXTINCT'],
      'BROWN STUDIO': ['SEXY FRENCH MOVEMENTS', 'DAVE N.A.'],
      'BLUE STUDIO': ['HOFMANN', 'GFRND'],
    },
  },
  {
    id: 'hor-tour',
    code: 'M-2025-014',
    title: 'HÖR ON TOUR',
    subtitle: 'BERLIN BROADCAST. ONE NIGHT.',
    date: '2025-11-21',
    doors: '23:00',
    close: '08:00',
    venue: 'hayfilm',
    state: 'low',
    capacity: 900,
    sold: 812,
    posterUrl: '/images/posters/hor-tour.jpg',
    tiers: [
      { id: 'early', name: 'EARLY-BIRD', price: 4000, qty: 50, remaining: 0, note: 'SOLD OUT' },
      { id: 'wave1', name: 'WAVE 1', price: 6000, qty: 100, remaining: 0, note: 'SOLD OUT' },
      { id: 'wave2', name: 'WAVE 2', price: 8000, qty: 200, remaining: 14, note: 'CLOSING' },
      { id: 'door', name: 'DOOR', price: 12000, qty: null, remaining: null, note: 'IF AVAILABLE' },
    ],
    lineup: {
      'MAIN STAGE': ['HÖR RESIDENT A', 'HÖR RESIDENT B', 'XTRM'],
      'PROJECTOR ROOM': ['ÉLÉKTRA', 'DENSEL', 'DIGBY'],
      'BROWN STUDIO': ['GEVORG SIMONYAN', 'ESTHETIC'],
    },
  },
  {
    id: 'antar-018',
    code: 'M-2026-002',
    title: 'ANTAR 018',
    subtitle: 'EXPERIMENTAL & AMBIENT NIGHT',
    date: '2026-03-07',
    doors: '21:00',
    close: '03:00',
    venue: 'ayrarat',
    state: 'available',
    capacity: 600,
    sold: 110,
    posterUrl: '/images/posters/antar-018.jpg',
    tiers: [
      { id: 'early', name: 'EARLY-BIRD', price: 3000, qty: 50, remaining: 28, note: 'OPEN' },
      { id: 'wave1', name: 'WAVE 1', price: 5000, qty: 100, remaining: 100, note: 'OPEN' },
      { id: 'door', name: 'DOOR', price: 7000, qty: null, remaining: null, note: 'IF AVAILABLE' },
    ],
    lineup: {
      'MAIN HALL': ['HOFMANN', 'NEBELL', 'IS (AM)', 'MIXTINCT', 'GUEST: TBA'],
    },
  },
  {
    id: 'moct-7',
    code: 'M-2026-003',
    title: 'MOCT 07 / IN FREQUENCY',
    subtitle: '7-YEAR ANNIVERSARY. 3 NIGHTS. 4 STAGES.',
    date: '2026-04-17',
    dateEnd: '2026-04-19',
    doors: '23:00',
    close: '12:00',
    venue: 'hayfilm',
    state: 'available',
    capacity: 3500,
    sold: 410,
    flagship: true,
    posterUrl: '/images/posters/moct-7.jpg',
    tiers: [
      { id: 'early', name: 'EARLY-BIRD', price: 12000, qty: 100, remaining: 38, note: 'CLOSING' },
      { id: 'wave1', name: 'WAVE 1', price: 18000, qty: 300, remaining: 300, note: 'OPEN' },
      { id: 'wave2', name: 'WAVE 2', price: 24000, qty: 500, remaining: 500, note: 'OPEN' },
      { id: 'door', name: 'DOOR', price: 30000, qty: null, remaining: null, note: 'IF AVAILABLE' },
    ],
    lineup: {
      'MAIN STAGE': ['HEADLINER: TBA', 'BEN KLOCK', 'NINA KRAVIZ', 'HOV'],
      'PROJECTOR ROOM': ['BINH', 'NICOLAS LUTZ', 'HESSILESS', 'MIXTINCT'],
      'BROWN STUDIO': ['DAVE N.A.', 'SEXY FRENCH MOVEMENTS', 'GFRND', 'DENSEL'],
      'BLUE STUDIO': ['HOFMANN', 'NEBELL', 'IS (AM)', 'ÉLÉKTRA'],
    },
  },
];

export const ARCHIVE: ArchiveEvent[] = [
  { id: 'dj-hell-2024',     code: 'M-2024-008', title: 'DJ HELL',                date: '2024-09-28', venue: 'hayfilm', headliners: ['DJ HELL', 'BINH', 'NICOLAS LUTZ'],                  posterUrl: '/images/posters/dj-hell-2024.jpg' },
  { id: 'moct-5',           code: 'M-2024-004', title: 'MOCT 05 / 5Y',           date: '2024-04-20', venue: 'hayfilm', headliners: ['BEN KLOCK', 'DIGBY', 'DENSEL', 'ÉLÉKTRA'],         posterUrl: '/images/posters/moct-5.jpg' },
  { id: 'jeff-mills-2023',  code: 'M-2023-010', title: 'JEFF MILLS',             date: '2023-07-23', venue: 'ayrarat', headliners: ['JEFF MILLS'],                                     posterUrl: '/images/posters/jeff-mills-2023.jpg' },
  { id: 'rodhad-2023',      code: 'M-2023-006', title: 'RØDHÅD',                 date: '2023-06-03', venue: 'hayfilm', headliners: ['RØDHÅD', 'DAVE N.A.', 'HOV'],                     posterUrl: '/images/posters/rodhad-2023.jpg' },
  { id: 'dettmann-2023',    code: 'M-2023-003', title: 'MARCEL DETTMANN',        date: '2023-03-18', venue: 'ayrarat', headliners: ['MARCEL DETTMANN', 'ABELLE', 'KARINA SAAKYAN'],    posterUrl: '/images/posters/dettmann-2023.jpg' },
  { id: 'villalobos-2022',  code: 'M-2022-011', title: 'RICARDO VILLALOBOS',     date: '2022-10-15', venue: 'ayrarat', headliners: ['RICARDO VILLALOBOS'],                             posterUrl: '/images/posters/villalobos-2022.jpg' },
  { id: 'kraviz-2022',      code: 'M-2022-005', title: 'NINA KRAVIZ',            date: '2022-05-28', venue: 'hayfilm', headliners: ['NINA KRAVIZ', 'HOPDOP'],                          posterUrl: '/images/posters/kraviz-2022.jpg' },
  { id: 'nastia-2021',      code: 'M-2021-009', title: 'NASTIA',                 date: '2021-09-04', venue: 'hayfilm', headliners: ['NASTIA'],                                         posterUrl: '/images/posters/nastia-2021.jpg' },
  { id: 'bassiani-2018',    code: 'M-2018-010', title: 'BASSIANI SHOWCASE',      date: '2018-10-30', venue: 'ayrarat', headliners: ['NDRX', 'NEWA', 'KANCHELI', 'ZITTO'],              posterUrl: '/images/posters/bassiani-2018.jpg' },
];

export const BOOKING_AGENCY: BookingAgency = {
  name: 'MOCT AGENCY',
  email: 'booking@moct.am',
  city: 'YEREVAN',
  hours: 'MON–FRI · 10:00–18:00 AMT',
  reply: 'TYPICAL REPLY 3–5 DAYS',
};

export const RESIDENTS: Resident[] = [
  {
    slug: 'hopdop', name: 'HOPDOP', role: 'RESIDENT', since: '2019', tag: 'TECHNO',
    genres: ['TECHNO', 'DETROIT', 'HYPNOTIC'], hometown: 'YEREVAN, AM', bpm: '128–138',
    bio: 'Founding resident. Heavy, hypnotic Detroit-leaning sets.',
    longBio: 'Founding member of the MOCT collective and one of the architects of its sonic identity. Long-form, hypnotic, weighted toward Detroit and early-2000s European techno. Resident at the Main Stage; opens and closes flagship nights.',
    links: {
      soundcloud: 'https://soundcloud.com/hopdopdj',
      ra: 'https://ra.co/dj/hopdop',
      facebook: 'https://www.facebook.com/hopdopdj/',
    },
    played: ['M-2024-008', 'M-2024-004', 'M-2022-005'],
    signature: [{ title: 'TRANSIT 04', length: '6:42', year: '2024' }, { title: 'NIGHT SHIFT', length: '7:18', year: '2023' }, { title: 'GORTSARAN MIX 12', length: '62:00', year: '2024' }],
    imageId: 'art-hopdop',
    portraitUrl: '/images/artists/hopdop.jpg',
  },
  {
    slug: 'xtrm', name: 'XTRM', role: 'RESIDENT', since: '2019', tag: 'TECHNO',
    genres: ['TECHNO', 'INDUSTRIAL', 'TRANCE'], hometown: 'YEREVAN, AM', bpm: '135–145',
    bio: 'Industrial textures. Long-form trance arcs.',
    longBio: 'Industrial textures bleeding into long-form trance arcs. Builds peak time slowly and ruthlessly. Frequent collaborator on ANTAR experimental nights.',
    links: {},
    played: ['M-2025-014', 'M-2024-008'],
    signature: [{ title: 'IRON BLOOM', length: '8:04', year: '2024' }, { title: 'EAST GATE', length: '7:30', year: '2023' }],
    imageId: 'art-xtrm',
    portraitUrl: '/images/artists/xtrm.jpg',
  },
  {
    slug: 'is-am', name: 'IS (AM)', role: 'RESIDENT', since: '2021', tag: 'TECHNO',
    genres: ['TECHNO', 'MODULAR'], hometown: 'YEREVAN, AM', bpm: '130–138',
    bio: 'Crisp, modular. Builds rooms slow then breaks them.',
    longBio: 'Crisp modular palette. Patient builds, sudden tears. Holds residency at the Projector Room and rotates onto Main Stage for closing slots.',
    links: {},
    played: ['M-2026-001', 'M-2026-002', 'M-2026-003'],
    signature: [{ title: 'MOD-SPLIT', length: '6:50', year: '2024' }, { title: 'CABLES', length: '5:20', year: '2023' }],
    imageId: 'art-is-am',
    portraitUrl: '/images/artists/is-am.jpg',
  },
  {
    slug: 'nebell', name: 'NEBELL', role: 'RESIDENT', since: '2022', tag: 'DEEP/MINIMAL',
    genres: ['DEEP', 'MINIMAL', 'DUB'], hometown: 'GYUMRI, AM', bpm: '124–130',
    bio: 'Projector Room regular. Reduced, dub-leaning.',
    longBio: 'Reduction as method. Long, dub-leaning sets at the Projector Room — low light, low BPM, high gravity. Ambient and mood-piece work under separate alias.',
    links: {},
    played: ['M-2026-001', 'M-2026-002', 'M-2026-003'],
    signature: [{ title: 'STRATA 02', length: '9:12', year: '2024' }, { title: 'DAMP', length: '7:42', year: '2024' }],
    imageId: 'art-nebell',
    portraitUrl: '/images/artists/nebell.jpg',
  },
  {
    slug: 'hessiless', name: 'HESSILESS', role: 'RESIDENT', since: '2022', tag: 'ACID/HOUSE',
    genres: ['ACID', 'HOUSE', 'BREAKS'], hometown: 'YEREVAN, AM', bpm: '128–140',
    bio: 'Closing sets at sunrise. Acid, breaks, joy.',
    longBio: 'Sunrise specialist. Acid, breaks, italo, joy — engineered for the last two hours when the room has nothing left to lose. MOCT 5 highlight closer.',
    links: { instagram: 'https://www.instagram.com/ccyless/' },
    played: ['M-2024-004'],
    signature: [{ title: '06:00 EDIT', length: '8:00', year: '2024' }, { title: 'TB-LOVE', length: '5:48', year: '2023' }],
    imageId: 'art-hessiless',
    portraitUrl: '/images/artists/hessiless.jpg',
  },
  {
    slug: 'mixtinct', name: 'MIXTINCT', role: 'RESIDENT', since: '2023', tag: 'TECHNO',
    genres: ['TECHNO', 'BROKEN'], hometown: 'YEREVAN, AM', bpm: '130–140',
    bio: 'Producer/DJ. Hypnotising late-night material.',
    longBio: 'Producer first. Live hardware sets and DJ rotations. Hypnotising late-night material with broken syncopations and dub treatments.',
    links: { soundcloud: 'https://soundcloud.com/mixtinct' },
    played: ['M-2026-001', 'M-2026-002', 'M-2026-003'],
    signature: [{ title: 'TONGUE-CUT', length: '6:30', year: '2025' }],
    imageId: 'art-mixtinct',
    portraitUrl: '/images/artists/mixtinct.jpg',
  },
  {
    slug: 'dave-na', name: 'DAVE N.A.', role: 'RESIDENT', since: '2020', tag: 'BREAKS/D&B',
    genres: ['BREAKS', 'JUNGLE', 'DUB', 'D&B'], hometown: 'YEREVAN, AM', bpm: '160–172',
    bio: 'Brown Studio cornerstone. Drum & bass, jungle, dub.',
    longBio: 'The Brown Studio cornerstone. Drum & bass, jungle, dub, dubstep — anything that hits hardest off-grid. Holds the bass-music torch in the MOCT residency. Releases on Uppers and Downers as Dave Nyxaether.',
    links: {
      instagram: 'https://www.instagram.com/davenyxaether/',
      ra: 'https://ra.co/dj/davena',
      bandcamp: 'https://davenyxaether.bandcamp.com/',
    },
    played: ['M-2026-001', 'M-2026-003', 'M-2023-006'],
    signature: [{ title: 'AYRARAT JUNGLE', length: '5:55', year: '2024' }],
    imageId: 'art-davena',
    portraitUrl: '/images/artists/dave-na.jpg',
  },
  {
    slug: 'hofmann', name: 'HOFMANN', role: 'RESIDENT', since: '2023', tag: 'HOUSE/TECHNO',
    genres: ['HOUSE', 'TECHNO', 'WARM'], hometown: 'YEREVAN, AM', bpm: '124–132',
    bio: 'Blue Studio shifts. Warm, club-functional.',
    longBio: 'Blue Studio resident. Warm, functional, club-first. Builds a room you want to stay inside until 06:00.',
    links: {},
    played: ['M-2026-001', 'M-2026-002', 'M-2026-003', 'M-2024-004'],
    signature: [{ title: 'BLUE ROTATION', length: '7:20', year: '2024' }],
    imageId: 'art-hofmann',
    portraitUrl: '/images/artists/hofmann.jpg',
  },
  {
    slug: 'hov', name: 'HOV', role: 'RESIDENT', since: '2019', tag: 'TECHNO',
    genres: ['TECHNO', 'CLASSIC'], hometown: 'YEREVAN, AM', bpm: '130–138',
    bio: 'Long-time selector. Original MOCT crew.',
    longBio: 'Original MOCT crew. Selector with a deep memory of European techno. Bridge between the early days at small venues and the Hayfilm era.',
    links: {},
    played: ['M-2026-003', 'M-2024-004', 'M-2023-006'],
    signature: [{ title: 'CUT-IN', length: '6:15', year: '2023' }],
    imageId: 'art-hov',
    portraitUrl: '/images/artists/hov.jpg',
  },
  {
    slug: 'gfrnd', name: 'GFRND', role: 'RESIDENT', since: '2021', tag: 'EXPERIMENTAL',
    genres: ['EXPERIMENTAL', 'AMBIENT', 'CLUB'], hometown: 'YEREVAN, AM', bpm: 'free',
    bio: 'Cross-format. ANTAR & Projector Room.',
    longBio: 'Cross-format. Moves between ANTAR experimental nights and Projector Room long-form sessions. No fixed BPM, no fixed genre — listening over format. Real name Youlia Zakaryan.',
    links: {
      soundcloud: 'https://soundcloud.com/gfrnd',
      ra: 'https://ra.co/dj/gfrnd',
      facebook: 'https://www.facebook.com/gfrndgfrndgfrnd',
    },
    played: ['M-2026-002', 'M-2026-003'],
    signature: [{ title: 'ANTAR PIECE 014', length: '22:00', year: '2024' }],
    imageId: 'art-gfrnd',
    portraitUrl: '/images/artists/gfrnd.jpg',
  },
  {
    slug: 'taronx', name: 'TARONX', role: 'RESIDENT', since: '2019', tag: 'ELECTRO/BREAKBEAT',
    genres: ['ELECTRO', 'BREAKBEAT', 'CLUB'], hometown: 'YEREVAN, AM', bpm: '128–140',
    bio: 'Eccentric taste, electro/breakbeat focus. Long-time Yerevan underground.',
    longBio: 'Yerevan-based DJ, producer, and artist with eccentric taste and vision in music. Over a decade as a musician; now fully dedicated to electronic music, honing in on electro and breakbeat while incorporating a diverse discography of genres into signature club-ready, energetic tracks. Regular at local raves, club nights, and radio/podcast series; collaborations with Wachita China, Fast Music Delivery, Ovelha Trax, and Ganzfeld Records.',
    links: {
      soundcloud: 'https://soundcloud.com/taronxxx',
      instagram: 'https://www.instagram.com/taronx__/',
    },
    played: ['M-2023-006', 'M-2024-004'],
    signature: [{ title: 'TBA — ELECTRO SET', length: '60:00', year: '2024' }],
    imageId: 'art-taronx',
    portraitUrl: '/images/artists/taronx.jpg',
  },
  {
    slug: 'karina-saakyan', name: 'KARINA SAAKYAN', role: 'GUEST RESIDENT', since: '2023', tag: 'ECLECTIC',
    genres: ['ECLECTIC', 'DEEP HOUSE', 'TECHNO'], hometown: 'TEL AVIV / YEREVAN', bpm: '120–132',
    bio: 'Two decades. Israel ↔ Yerevan crossings.',
    longBio: 'Two decades behind decks. Permanent crossings between Tel Aviv and Yerevan. Joined MOCT as a guest resident — slots reserved for flagship events and Ayrarat nights. Resident DJ at DIARIES queer collective.',
    links: {
      soundcloud: 'https://soundcloud.com/karinasaakyan',
      instagram: 'https://www.instagram.com/saakkarina/',
      ra: 'https://ra.co/dj/karinasaakyan',
      facebook: 'https://www.facebook.com/karinasaakyandj',
    },
    played: ['M-2026-001', 'M-2023-003'],
    signature: [{ title: 'CROSSINGS', length: '7:30', year: '2024' }],
    imageId: 'art-karina',
    portraitUrl: '/images/artists/karina-saakyan.jpg',
  },
];

export function residentSlug(name: string | null | undefined): string | null {
  if (!name) return null;
  const target = name.trim().toUpperCase();
  return RESIDENTS.find((r) => r.name.toUpperCase() === target)?.slug ?? null;
}

export const FEATURED_GUESTS: readonly FeaturedGuest[] = [
  {
    name: 'JUAN ATKINS',
    tagline: "Detroit techno originator; Cybotron / Model 500; Metroplex label founder; 'godfather of techno'.",
    wikipedia: 'https://en.wikipedia.org/wiki/Juan_Atkins',
    ra: 'https://ra.co/dj/juanatkins',
    hometown: 'DETROIT, US',
    portraitUrl: '/images/guests/juan-atkins.jpg',
  },
  {
    name: 'NINA KRAVIZ',
    tagline: 'трип (Trip) and NK label founder; Berghain/Amnesia/Space resident.',
    wikipedia: 'https://en.wikipedia.org/wiki/Nina_Kraviz',
    ra: 'https://ra.co/dj/ninakraviz',
    hometown: 'IRKUTSK, RU',
    portraitUrl: '/images/guests/nina-kraviz.jpg',
  },
  {
    name: 'JEFF MILLS',
    tagline: "Detroit pioneer 'The Wizard'; Underground Resistance co-founder; Axis Records (1992).",
    wikipedia: 'https://en.wikipedia.org/wiki/Jeff_Mills',
    ra: 'https://ra.co/dj/jeffmills',
    hometown: 'DETROIT, US',
    portraitUrl: '/images/guests/jeff-mills.jpg',
  },
  {
    name: 'RICARDO VILLALOBOS',
    tagline: 'Chilean-German minimal-techno cornerstone.',
    wikipedia: 'https://en.wikipedia.org/wiki/Ricardo_Villalobos',
    ra: 'https://ra.co/dj/ricardovillalobos',
    hometown: 'SANTIAGO / DARMSTADT',
    portraitUrl: '/images/guests/ricardo-villalobos.jpg',
  },
  {
    name: 'RØDHÅD',
    tagline: 'Berlin; Dystopian label founder; deep, melancholic looptechno.',
    wikipedia: 'https://en.wikipedia.org/wiki/R%C3%B8dh%C3%A5d',
    ra: 'https://ra.co/dj/rodhad',
    hometown: 'BERLIN, DE',
    portraitUrl: '/images/guests/rodhad.jpg',
  },
  {
    name: 'MARCEL DETTMANN',
    tagline: 'Berghain resident; MDR label founder.',
    wikipedia: 'https://en.wikipedia.org/wiki/Marcel_Dettmann',
    ra: 'https://ra.co/dj/marceldettmann',
    hometown: 'BERLIN, DE',
    portraitUrl: '/images/guests/marcel-dettmann.jpg',
  },
  {
    name: 'BEN KLOCK',
    tagline: 'Berghain resident since 2005; Klockworks founder.',
    wikipedia: 'https://en.wikipedia.org/wiki/Ben_Klock',
    ra: 'https://ra.co/dj/benklock',
    hometown: 'BERLIN, DE',
    portraitUrl: '/images/guests/ben-klock.jpg',
  },
  {
    name: 'DJ HELL',
    tagline: 'International Deejay Gigolo Records; electroclash key figure.',
    wikipedia: 'https://en.wikipedia.org/wiki/DJ_Hell',
    hometown: 'BAVARIA, DE',
    portraitUrl: '/images/guests/dj-hell.jpg',
  },
  {
    name: 'BINH',
    tagline: 'Time Passages label; Club der Visionaere regular.',
    ra: 'https://ra.co/dj/binh',
    hometown: 'BERLIN, DE',
    portraitUrl: '/images/guests/binh.jpg',
  },
  {
    name: 'NICOLAS LUTZ',
    tagline: 'My Own Jupiter label; instinct-driven selector.',
    ra: 'https://ra.co/dj/nicolaslutz',
    hometown: 'MONTEVIDEO / MALLORCA',
    portraitUrl: '/images/guests/nicolas-lutz.jpg',
  },
  {
    name: 'NASTIA',
    tagline: 'NECHTO Records; Strichka Festival co-founder.',
    ra: 'https://ra.co/dj/nastia',
    hometown: 'UA / AMSTERDAM',
    portraitUrl: '/images/guests/nastia.jpg',
  },
  {
    name: 'ABELLE',
    tagline: 'Moscow techno; ARMA17 / ARMA label.',
    ra: 'https://ra.co/dj/abelle',
    hometown: 'MOSCOW, RU',
  },
];

export const TIMELINE: readonly TimelineEntry[] = [
  { y: '2019', t: 'MOCT founded. First nights at small venues across Yerevan.' },
  { y: '2020', t: 'ANTAR project launches. Experimental & ambient series.' },
  { y: '2021', t: 'Projector Room series begins. Long-form sets, low light.' },
  { y: '2022', t: 'Nina Kraviz, Ricardo Villalobos at Ayrarat Cinema.' },
  { y: '2023', t: 'Hayfilm Cluster opens. 4 stages. Rødhåd, Jeff Mills, Dettmann.' },
  { y: '2024', t: 'MOCT 5. DJ Hell. Gortsaran FM radio launches.' },
  { y: '2026', t: 'MOCT 07 / IN FREQUENCY — 7-year anniversary.' },
];
